import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '../../types/endpoints';
import type { ApiQueryParams } from '../../types/apiQuery';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit'>;

type Response = {
  count: number;
};

/** Count for the global cross-model imports feed. */
export const getAllImportsCount = async (
  scope: RequestScope,
  { limit = 1000 }: RequestParams = {},
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`imports/count?limit=${limit}`, requestOptions);

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
